import rustika from './images/rustika2.png'
import progressio from './images/progressio.png'
import odyssey from './images/odyssey.png'
import gameshub from './images/gameshub.png'
import maturepips from './images/maturepips.png'
import medikraft from './images/medikraft.png'

import css from './icons/css.svg'
import django from './icons/django.svg'
import javascript from './icons/javascript.svg'
import react from './icons/react.svg'
import redux from './icons/redux.svg'
import sass from './icons/sass.svg'
import html from './icons/html.svg'
import mongo from './icons/mongodb.svg'
import ts from './icons/ts.svg'
import next from './icons/next.svg'
import wix from './icons/wix.svg'
import tailwind from './icons/tailwind.svg'

export const works = [

    {
        id: 7,
        name: 'Medikraft',
        image: medikraft,
        status: 'completed',
        client: 'Personal',
        roles: 'Front-end, Backend',
        link: 'https://medikraft.vercel.app/',
        technologies: [
            next,
            ts,
            tailwind,
            wix,
            
        ]
    },

    {
        id: 6,
        name: 'MaturePips',
        image: maturepips,
        status: 'completed',
        client: 'Personal',
        roles: 'Front-end, Backend',
        link: 'https://maturepips.vercel.app/',
        technologies: [
            next,
            ts,
            tailwind,
            mongo
        ]
    },

    {
        id: 5,
        name: 'GamesHub',
        image: gameshub,
        status: 'completed',
        client: 'Personal',
        roles: 'Front-end, Backend',
        link: 'https://gameshub-nine.vercel.app/',
        technologies: [
            next,
            ts,
            tailwind,
            mongo,
        ]
    },

    

    {
        id: 3,
        name: 'Rustika Shop',
        image: rustika,
        status: 'showcase',
        client: 'Personal',
        roles: 'Front-end, Backend, Design',
        link: 'https://drive.google.com/file/d/1LJEqJUIThbKMH7tFb6WuKBTtvzamEhNm/view?usp=drive_link',
        technologies: [
            react,
            redux,
            css,
            django
        ]
    },

    {
        id: 2,
        name: 'Progressio Training Center',
        image: progressio,
        status: 'completed',
        client: 'Progressio Training Center',
        roles: 'Front-end, Backend, Design',
        link: 'https://progressio.netlify.app/',
        technologies: [
            html,
            sass,
            javascript,
        ]
    },

    {
        id: 1,
        name: 'Odyssey Learning Center',
        image: odyssey,
        status: 'in progress',
        client: 'Odyssey Learning Center Center',
        roles: 'Front-end, Backend, Design',
        link: '#',
        technologies: [
            react,
            redux,
            css,
            django
        ]
    },
]
